import React, { useEffect } from "react";

import Aos from "aos";
import "aos/dist/aos.css";

const Contact = () => {
	useEffect(() => {
		Aos.init({
			duration: 1500,
			delay: 200,
			offset: 0,
			easing: "ease",
			once: true,
			mirror: false,
			disable: () => {
				return window.innerWidth < 600;
			},
		});

		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="contact">
			<div className="contact-heading" data-aos="flip-down">
				Contact Me
			</div>
			<div className="contacts-container">
				<div
					className="contacts"
					data-aos="zoom-out"
					data-aos-delay="1000"
				>
					<a
						href="mailto:mahawart99@gmail.com"
						target="_blank"
						rel="noreferrer"
					>
						<div className="item">
							<i className="fas fa-envelope-open-text odd" />
							<div className="item-label">Email</div>
						</div>
					</a>
					<a
						href="https://www.linkedin.com/in/tilak-mahawar-782851200/"
						target="_blank"
						rel="noreferrer"
					>
						<div className="item">
							<i className="fab fa-linkedin even" />
							<div className="item-label">Linked In</div>
						</div>
					</a>
					<a
						href="https://github.com/mr-mahawar"
						target="_blank"
						rel="noreferrer"
					>
						<div className="item">
							<i className="fab fa-github odd" />
							<div className="item-label">Git Hub</div>
						</div>
					</a>
					<a
						href="https://twitter.com/mr_mahawar"
						target="_blank"
						rel="noreferrer"
					>
						<div className="item">
							<i className="fab fa-twitter even" />
							<div className="item-label">Twitter</div>
						</div>
					</a>
					<a
						href="https://www.instagram.com/__mr.mahawar__/"
						target="_blank"
						rel="noreferrer"
					>
						<div className="item">
							<i className="fab fa-instagram odd" />
							<div className="item-label">Instagram</div>
						</div>
					</a>
				</div>
			</div>
		</div>
	);
};

export default Contact;
